import { InformationRequestsService } from './../services/information-requests.service';
import { ProfesionalesFormDialogComponent } from './../nosotros/nuestros-profesionales/profesionales-form-dialog/profesionales-form-dialog.component';
//import { SociosFormDialogComponent } from './socios-form-dialog/socios-form-dialog.component';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-socios',
  templateUrl: './socios.component.html',
  styleUrls: ['./socios.component.scss']
})
export class SociosComponent implements OnInit {

  sociosForm: FormGroup;

  constructor(public dialog: MatDialog, private informationRequestsService: InformationRequestsService) { 
    this.buildForm();
  }

  openDialog() {
    this.dialog.open(ProfesionalesFormDialogComponent);
  }
  
  ngOnInit(): void {
  }

  private buildForm() {
    this.sociosForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      surname: new FormControl('', [Validators.required]),
      phone_number: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email, Validators.required]),
    });
  }

  save(event: Event) {
    event.preventDefault();
    if (this.sociosForm.valid) {
      const value = this.sociosForm.value;
      value['request_type']="socios";
      console.log(value);
      this.informationRequestsService.saveForm(value)
        .subscribe(
          res => {
            console.log(res);
          },
          err => console.log(err)
        )
      this.openDialog();
    } else {
      this.sociosForm.markAllAsTouched();
    }
  }

}
